package org.example.zone360.components

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.css.TransitionProperty
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.opacity
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.silk.components.text.SpanText
import kotlinx.coroutines.delay
import org.example.zone360.componentss.FieldTitleTextNormalSimple
import org.example.zone360.theme.SitePalette
import org.jetbrains.compose.web.css.ms
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Text

@Composable
fun TypingDot(delayMs: Int) {
    var visible by remember { mutableStateOf(true) }

    LaunchedEffect(Unit) {
        while (true) {
            delay(delayMs.toLong())
            visible = true
            delay(300)
            visible = false
            delay(300)
        }
    }

    Box(
        modifier = Modifier
            .size(5.px)
            .borderRadius(100.percent)
            .backgroundColor(Colors.Black.copyf(alpha = if (visible) 1.0f else 0.2f))
    )
}

val thinkingLabels = listOf("Thinking", "Reading data", "Analysing", "Almost there")

@Composable
fun CyclingThinkingIndicator() {
    var phase by remember { mutableStateOf(0) }
    var visible by remember { mutableStateOf(true) }
    var dotCount by remember { mutableStateOf(1) }

    LaunchedEffect(Unit) {
        while (true) {
            delay(400)
            dotCount = if (dotCount == 3) 1 else dotCount + 1
        }
    }

    LaunchedEffect(Unit) {
        while (phase < thinkingLabels.size - 1) {
            delay(2500)
            visible = false
            delay(150)
            phase++
            visible = true
        }
    }

    val baseLabel = thinkingLabels[phase].trimEnd('.')
    val animatedText = baseLabel + ".".repeat(dotCount)

    SpanText(
        text = animatedText,
        modifier = Modifier
            .opacity(if (visible) 1f else 0f).fontSize(14.px).color(Colors.Gray)
            .transition(Transition.of(TransitionProperty.All, 150.ms))
    )
}

@Composable
fun CyclingThinkingIndicator(
    text: String
) {
    var dotCount by remember { mutableStateOf(1) }

    LaunchedEffect(Unit) {
        while (true) {
            delay(400)
            dotCount = if (dotCount == 3) 1 else dotCount + 1
        }
    }

    SpanText(
        text = text + ".".repeat(dotCount),
        modifier = Modifier
            .fontSize(14.px)
            .color(Colors.Gray)
    )
}